import PropTypes from 'prop-types';
import React, { Component } from 'react';

import {
  Container,
  Instructions,
  FieldValue,
} from './styles';

class TaskQuestionType extends Component {
  componentDidMount() {
    this.answerQuestion();
  }

  answerQuestion = (touched = false) => {
    const { question, onQuestionAnswered } = this.props;
    const { id: questionId } = question;

    onQuestionAnswered({
      questionId,
      error: null,
      touched,
    });
  }

  render() {
    const { question } = this.props;
    const { labelPreview, label } = question;

    return (
      <Container>
        <FieldValue>{labelPreview || label}</FieldValue>
        <Instructions>Remember to speak your thoughts aloud.</Instructions>
      </Container>
    );
  }
}

TaskQuestionType.propTypes = {
  question: PropTypes.object.isRequired,
  onQuestionAnswered: PropTypes.func.isRequired,
};

export default TaskQuestionType;
